export default __webpack_public_path__ + "static/media/services_food.3de63f99.jpg";